import { useEffect } from "react";
import DatePicker from "react-datepicker";
import type { MetaDataPropertyType } from "./../../../../types/metaDataPropertyTypes";
import type { PropertyCriteria } from "./../../../../types/qbank/propertyCriteria";
import { SearchOperator } from "./../../../../types/qbank/searchOperator";
import "react-datepicker/dist/react-datepicker.css";

export default function DateSelect(props: {
  propertyType: MetaDataPropertyType;
  setCriteria: (propertyCriteria: PropertyCriteria) => void;
  setDate: (date?: string) => void;
  value: string;
}) {
  useEffect(() => {
      props.setCriteria({
        id: props.propertyType.id,
        systemName: props.propertyType.systemname,
        operator: SearchOperator.EQUAL,
        value: props.value !== undefined && props.value.length ? props.value : undefined,
        label: props.propertyType.name,
      });
    // eslint-disable-next-line
  }, [props.value]);

  return (
    <div className="field" data-testid="date">
      <label className="label">{props.propertyType.name}</label>

      <div className="control">
        <DatePicker
          className="input is-fullwidth"
          dateFormat="yyyy-MM-dd"
          selected={props.value ? new Date(props.value) : undefined}
          onChange={(date) =>
            props.setDate(
              date instanceof Date
                ? date.toISOString().split("T")[0]
                : undefined
            )
          }
          isClearable
        />
      </div>
    </div>
  );
}
